import { render, staticRenderFns } from "./categoryPicker.vue?vue&type=template&id=1af51be5"
import script from "./categoryPicker.vue?vue&type=script&lang=js"
export * from "./categoryPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports